<template>
  <div>
    <v-btn
      class="menu-button"
      fab
      small
      @click="changeDrawer()"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-aframe />
    <component
      :is="currentComponent"
      @selectComponent="teste($event)"
      @nextStep="changeStepper($event)"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  components: {
    CoreEtapa1: () => import('@/components/core/Etapa1'),
    CoreEtapa2: () => import('@/components/core/Etapa2'),
    CoreEtapa3: () => import('@/components/core/Etapa3'),
    CoreEtapa4: () => import('@/components/core/Etapa4'),
    CoreEtapa5: () => import('@/components/core/Etapa5'),
    VAframe: () => import('@/components/core/Aframe'),
    Drawer: () => import('@/components/core/Drawer')
  },
  data () {
    return {
      currentComponent: 'CoreEtapa1'
    }
  },
  beforeMount () {
    // console.log('component', this.$component)
  },
  methods: {
    ...mapMutations('app', ['setStepper', 'setDrawer', 'toggleDrawer']),
    changeDrawer () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    changeStepper (stepper) {
      this.setStepper(stepper)
    },
    teste (event) {
      this.currentComponent = event
    }
  }
}

</script>

<style>
  .menu-button{
    z-index:1000;
    position:absolute;
    top:15px;
    left:15px;
    border-radius: 4px;
  }
  @media only screen and (max-width: 600px) {
  .menu-button{
    z-index:1000;
    position:absolute;
    top:0px;
    left:0px;
    border-radius: 4px;
  }
}
</style>
